import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import { gray_1 } from 'components/corpSite/components/theme/colors'
import { xsMd } from 'components/corpSite/components/theme/utils/media-query'
import { spacing_0_5, spacing_3 } from 'components/corpSite/components/theme/spacing'

const StyledBackground = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.background || gray_1};
  width: ${(props) => props.radius}px;
  height: ${(props) => props.radius}px;
  border-radius: ${(props) => props.radius / 2}px;
  margin-bottom: ${(props) => props.marginBottom || spacing_0_5};
  margin-right: ${(props) => props.marginRight || spacing_3};

  ${() =>
    xsMd(css`
       {
        margin-left: auto;
        margin-right: auto;
        margin-bottom: ${(props) => props.marginBottomMobile || props.marginBottom || spacing_0_5};
      }
    `)}
`

const CircledIcon = ({ icon, radius, ...props }) => (
  <StyledBackground radius={radius} {...props}>
    <img src={icon} />
  </StyledBackground>
)

CircledIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  radius: PropTypes.number.isRequired,
}

export default CircledIcon
